'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgReceipt(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M10.853 2c.497 0 .677.052.858.149.182.097.324.24.422.421.087.163.138.326.147.719l.001 9.283c0 .496-.051.676-.148.858-.098.182-.24.324-.422.421-.181.097-.361.149-.858.149H5.138c-.496 0-.676-.052-.858-.149a1.012 1.012 0 01-.421-.421c-.097-.182-.149-.362-.149-.858V3.428c0-.496.052-.676.149-.858.097-.182.24-.324.421-.421.163-.088.326-.138.719-.147L10.853 2zm-2.257 8.914H6.624a.514.514 0 000 1.029h1.972a.514.514 0 100-1.029zm.857-2.057H6.624a.514.514 0 100 1.029h2.829a.514.514 0 000-1.029zM7.996 3.714c-.71 0-1.286.553-1.286 1.233 0 .734.812 1.747 1.144 2.132a.187.187 0 00.281 0c.335-.385 1.146-1.398 1.146-2.132 0-.68-.576-1.233-1.285-1.233zm0 .857c.24 0 .428.187.428.429a.423.423 0 01-.428.429A.423.423 0 017.567 5c0-.242.188-.429.429-.429z", fill: "currentColor", fillRule: "evenodd" })));
}

module.exports = SvgReceipt;
//# sourceMappingURL=Receipt.js.map
